import React, { FC } from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';
import firebase from "firebase/compat/app";
import 'firebase/compat/auth';
import "../styles/main.css";
import brand from '../img/CCCR.svg';
import { LinkContainer } from 'react-router-bootstrap';

interface HeaderInterface {
    user: any;
}

const Header: FC<HeaderInterface> = (props: HeaderInterface) => {
    const { user } = props;

    return (
        <Navbar bg="light" variant="light" collapseOnSelect expand="lg">
            <Container>
                <LinkContainer to='/'>
                    <Navbar.Brand>
                        <img
                            src={brand}
                            width="60"
                            // height="315"
                            // className="d-inline-block align-top"
                            alt="React Bootstrap logo"
                        />
                    </Navbar.Brand>
                </LinkContainer>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="me-auto">
                        {(user?.admin) && <LinkContainer to='/cycles'>
                            <Nav.Link>Ciclo escolar</Nav.Link>
                        </LinkContainer>}
                        {(user?.admin || user?.teacher) && <LinkContainer to='/locations'>
                            <Nav.Link>Ubicaciones</Nav.Link>
                        </LinkContainer>}
                        {(user?.admin || user?.teacher) && <LinkContainer to='/activities'>
                            <Nav.Link>Actividades</Nav.Link>
                        </LinkContainer>}
                        {(user?.admin) && <LinkContainer to='/users'>
                            <Nav.Link>Usuarios</Nav.Link>
                        </LinkContainer>}
                        {(user?.admin) && <LinkContainer to='/userGroups'>
                            <Nav.Link>Grupo de usuarios</Nav.Link>
                        </LinkContainer>}
                        {user?.student && <LinkContainer to='/inscriptions'>
                            <Nav.Link>Registration</Nav.Link>
                        </LinkContainer>}
                        {user?.student && <LinkContainer to='/myActivities'>
                            <Nav.Link>My activities</Nav.Link>
                        </LinkContainer>}
                    </Nav>
                    <Nav>
                        {/* <div className="round"><img src={firebase.auth().currentUser?.photoURL ?? ""} height="20px" width="20px" /></div> */}
                        <Nav.Link onClick={() => {
                            firebase.auth().signOut();
                        }}>Logout</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}

export default Header;
